module.exports = __webpack_public_path__ + "img/stan-miller.26d1481b.jpg";